export type ConnectorOrientation = "horizontal" | "vertical";

export interface Point {
  x: number;
  y: number;
}

interface BuildConnectorPathOptions {
  orientation: ConnectorOrientation;
  start: Point;
  end: Point;
}

const formatCoordinate = (value: number) => {
  if (Number.isInteger(value)) {
    return `${value}`;
  }

  return `${Number(value.toFixed(3))}`;
};

export const buildConnectorPath = ({ orientation, start, end }: BuildConnectorPathOptions) => {
  const curveOffset =
    orientation === "horizontal"
      ? Math.abs(end.x - start.x) * 0.45
      : Math.abs(end.y - start.y) * 0.45;

  if (orientation === "horizontal") {
    return [
      `M${formatCoordinate(start.x)},${formatCoordinate(start.y)}`,
      `C${formatCoordinate(start.x + curveOffset)},${formatCoordinate(start.y)}`,
      `${formatCoordinate(end.x - curveOffset)},${formatCoordinate(end.y)}`,
      `${formatCoordinate(end.x)},${formatCoordinate(end.y)}`,
    ].join(" ");
  }

  return [
    `M${formatCoordinate(start.x)},${formatCoordinate(start.y)}`,
    `C${formatCoordinate(start.x)},${formatCoordinate(start.y + curveOffset)}`,
    `${formatCoordinate(end.x)},${formatCoordinate(end.y - curveOffset)}`,
    `${formatCoordinate(end.x)},${formatCoordinate(end.y)}`,
  ].join(" ");
};

export const getConnectorOrientation = (viewportWidth: number): ConnectorOrientation => {
  void viewportWidth;

  return "horizontal";
};
